import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FiEye, FiPlus } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import config from 'config/environment';
import { useModal } from 'hooks/modal';

import Pagination from 'components/Pagination';
import Button from 'components/Button';
import NotFound from 'components/NotFound';
import Loader from 'components/ContentLoader/GenericLoader';
import Avatar from 'components/Avatar';
import Card from 'components/Card';
import Tooltip from 'components/Tooltip';

import NoSolicitacaoChamada from 'assets/Fill out-pana.svg';
import api from 'services/api';
import AppError from 'utils/AppError';
import { Emissora, Programa, Usuario } from 'pages/@types';

import { Container, NovoInfo, Table } from './styles';
export interface ISugestaoPromo {
  id: number;
  nome: string;
  informacoes: string;
  materialgravado: string;
  programa: Programa;
  emissora: Emissora;
  solicitante: Usuario;
  download_url: string;
}

export default function SugestaoPromo() {
  // react-router-dom
  const navigate = useNavigate();
  /**
   * USE STATE
   */
  const [sugestoes, setSugestoes] = useState<ISugestaoPromo[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loadingDownload, setLoadingDownload] = useState(false);

  /**
   * Hooks
   */
  const { showModal, hideModal } = useModal();
  /**
   * USE EFFECT
   */
  useEffect(() => {
    const controller = new AbortController();
    async function loadSugestao() {
      try {
        setLoading(true);
        const response = await api.get('/sugestaopromo', {
          signal: controller.signal,
          params: {
            page,
          },
        });
        if (response && response.data) {
          setPages(response.data.pages);
          setSugestoes(response.data.sugestoes);
        } else toast.error('Falha de comunicação com o servidor');
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else if (e instanceof AppError) toast.error(e.message);
        else {
          const appError = e as AppError;
          if (appError.message) toast.error(appError.message);
          else toast.error('Erro inesperado');
        }
      }
      setLoading(false);
    }
    loadSugestao();
    return () => {
      controller.abort();
    };
  }, [page]);

  const renderNovo = useCallback(() => {
    return (
      <NovoInfo>
        <p>
          Obrigada por cuidar da programação com a gente e compartilhar sua
          ideia!
          <br />
          Vamos endenter como a sugestão se encaixa com o tom de voz do produto,
          nosso planejamento e, claro, sugerir datas de entrega.
        </p>
        <p>
          Qualquer dúvida, pode entrar em contato com a coordenação de Promo:
          <b>(41) 3340 7952</b> ou <b>(41) 99886 9334</b>
        </p>
        <div>
          <Button
            color="primary"
            onClick={() => (hideModal(), navigate('/sugestaopromo/novo'))}
          >
            CRIAR NOVA SUGESTÃO
          </Button>
        </div>
      </NovoInfo>
    );
  }, [navigate, hideModal]);

  const handleNovo = useCallback(() => {
    showModal({
      width: '47vw',
      title: 'SUGESTÃO DE PROMO',
      component: renderNovo(),
    });
  }, [renderNovo, showModal]);

  return (
    <Container>
      <Card>
        <header>
          <h4>LISTA DE SUGESTÕES DE PROMO</h4>
          <Pagination
            total={pages}
            activePage={page}
            onClick={page => setPage(page)}
          />
          <Button
            color="primary"
            onClick={handleNovo}
            tooltip="Criar nova Sugestão de Promo"
            disabled={loadingDownload}
          >
            CRIAR NOVA SUGESTÃO
            <FiPlus />
          </Button>
        </header>
        {loading ? (
          <Loader />
        ) : !!sugestoes && sugestoes.length ? (
          <div style={{ padding: `0 15px` }}>
            <Table>
              <thead>
                <tr>
                  <th>NOME</th>
                  <th>EXIBIDORA</th>
                  <th>SOLICITANTE</th>
                  <th>VISUALIZAR</th>
                </tr>
              </thead>
              <tbody>
                {sugestoes.map(s => (
                  <tr key={s.id}>
                    <td>{s.nome}</td>
                    <td>{s.emissora}</td>
                    <td>
                      <Avatar
                        size="40"
                        name={s.solicitante?.nome}
                        src={s.solicitante?.avatar_url}
                        round
                      />
                    </td>
                    <td>
                      <Button
                        id={`id_visualizar_${s.id}`}
                        fill
                        color="font"
                        round
                        onClick={e => {
                          e.preventDefault();
                          window.open(`${s.download_url}`, '_blank');
                        }}
                        disabled={loadingDownload}
                      >
                        <FiEye />
                      </Button>
                      <Tooltip target={`id_visualizar_${s.id}`}>
                        VISUALIZAR
                      </Tooltip>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <NotFound img={NoSolicitacaoChamada} title="Sugestão Promo">
            Nenhuma Sugestão de Promo encontrada
          </NotFound>
        )}
      </Card>
    </Container>
  );
}
